import React from "react";
import PropTypes from "prop-types";
import { List } from "immutable";
import { Row, Col, Modal, Input } from "antd";
import CompanyDocumentViewList from "./templates/company-attachments-list";
import DocumentViewForm from "./forms/document-view-form";
import CompanyLosServices from "./services/company-los-services";
// import CompanyAttachmentTable from "./templates/company-attachments-table";
import CompanyAttachmentUploadModal from "./templates/company-attachment-upload-modal";
import { STATE_STATUS } from "./constants";
import "styles/document-review.css";
import DocumentRequestModal from "../../templates/case-action-modals/document-request-modal";

class CompanyAttachmentsDisplay extends React.Component {
    state = {
        isUploadModalVisible: false,
        formValues: {},
        selectedFile: null,
        selectedFilePath: null,
        selectedFileType: null,
        requestModal: false,
        showRequestedRemarks: false,
        requestedRemarks: null
    }

    componentDidMount() {
        if (!this.props.attachments || this.props.attachments.get("status", STATE_STATUS.UNFETCHED) === STATE_STATUS.UNFETCHED) {
            this.props.fetchCompanyLosAttachments(this.props.companyId);
        }
        if(this.props.isDBOnBoarding){
            CompanyLosServices.fetchDocumentMasterList(this.props.companyId).then(response => {
                if(response.data) {
                    this.docMasterList = (response.data || []);
                    this.forceUpdate();
                }
                return [];
            });
        }else{
            CompanyLosServices.fetchDocumentMasterList().then(response => {
                if(response.data) {
                    this.docMasterList = (response.data || []);
                    this.forceUpdate();
                }
                return [];
            });
        }
        
    }

    componentDidUpdate(prevProps) {
        if(this.props.deleteDocumentStatus == STATE_STATUS.FETCHED && prevProps.deleteDocumentStatus == STATE_STATUS.FETCHING && this.props.isDBOnBoarding){
            this.props.fetchCompanyLosAttachments(this.props.companyId);
        }
        if(this.props.companyDocStatus.get("requestRemarksStatus") == STATE_STATUS.FETCHED && prevProps.companyDocStatus.get("requestRemarksStatus") == STATE_STATUS.UNFETCHED && this.props.isDBOnBoarding){
            this.props.fetchCompanyLosAttachments(this.props.companyId);
        }
        this.closeUploadModalAfterSuccess(prevProps, this.props);
    }


    async handleFilesFetch() {
        if (
            this.props.companyId &&
            (this.props.filesStatus === STATE_STATUS.UNFETCHED)
        ) {
            this.props.fetchCompanyDocuments(
                this.props.caseId,
                this.props.companyId
            );
        }
    }


    getLoading() {
        if (this.props.attachments && this.props.attachments.get("status") === STATE_STATUS.FETCHING) {
            return true;
        }
        return false;
    }

    getValues() {
        const BASE_LIST = new List([]);
        if (this.props.attachments && this.props.attachments.get("data")) {
            if(this.props.isDBOnBoarding){
                let documents = List(this.props.attachments.get("data", BASE_LIST)).groupBy(_ => _.document && _.document.id);
                let groupedDocs = documents.map(_ => _.reduce((a, b) => {
                    if(b.document.id == 8){
                        let allOptionDocs = [];
                        let aadharFront = documents.get(8).filter(_ => _.document_option == 12).reduce((a,b) => {
                            return new Date(a.create_date) > new Date(b.create_date) ? a : b;
                        });
                        let aadharback = documents.get(8).filter(_ => _.document_option == 13) ? documents.get(8).filter(_ => _.document_option == 13).reduce((a,b) => {
                            return new Date(a.create_date) > new Date(b.create_date) ? a : b;
                        }) : [];
                        if(aadharFront){
                            allOptionDocs.push(aadharFront);
                        }
                        if(aadharback){
                            allOptionDocs.push(aadharback);
                        }
                        return allOptionDocs;
                    }else{
                        return new Date(a.create_date) > new Date(b.create_date) ? a : b;
                    }
                }));
                return List(groupedDocs.toList().toJS().flat());
            }
            return this.props.attachments.get("data", BASE_LIST);
        }
        return BASE_LIST;
    }

    toggleUploadModal = () =>
        this.setState({
            isUploadModalVisible: !this.state.isUploadModalVisible
        })

    onSubmit = (values) => {
        const updated_value = {...values, "mpa_approval_id" : (values.documentId == 56 && this.props.currentMpaId) ?  this.props.currentMpaId : undefined};
        this.setState({
            formValues: updated_value
        },
        () => this.props.uploadCompanyLosAttachment(this.props.companyId, updated_value));
    }
    isFormSubmitting() {
        if (this.props.attachments.getIn(["upload", "status"]) === STATE_STATUS.UPLOADING) {
            return true;
        }
        return false;
    }

    getFormValues() {
        return this.state.formValues;
    }

    isFormSubmitFailed() {
        if (this.props.attachments.getIn(["upload", "status"]) === STATE_STATUS.UPLOAD_FAILED) {
            return true;
        }
        return false;
    }

    closeUploadModalAfterSuccess(prevProps) {
        if (
            this.props.attachments.getIn(["upload", "status"]) === STATE_STATUS.UPLOADED &&
            prevProps.attachments.getIn(["upload", "status"]) === STATE_STATUS.UPLOADING
        ) {
            this.setState({
                isUploadModalVisible: false,
                formValues: {}
            });
        }
    }

    viewDoc = file => {
        const filePath = file.file;
        const fileNameArr = (file.file && file.file.split("/").reverse()[0].split(".")) || [];
        const fileType = fileNameArr.reverse()[0];

        this.setState(
            {
                selectedFileType: fileType,
                selectedFilePath: filePath,
                selectedFile: file,
                fileName: file.file_name
            },
            () => this.forceUpdate()
        );
    };

    changeName = file => {
        // this.props.validateDocument(
        //     this.props.companyId,
        //     null,
        //     file
        // );
        console.log(file);
    };

    addRequestedRemark = (docId, document) => {
        this.setState({
            selectedFile: document,
            showRequestedRemarks: true,
            requestedRemarks: document.request_remarks
        });
    };


    deleteRequestedDocument = (docId, document) => {
        let selectedDoc = { ...document, ...{ is_active: false } };

        this.props.dbOnboardingInvalidateDocumentHandler(
            this.props.companyId,
            selectedDoc,
        );
        this.setState(
            {
                selectedFilePath: null,
                selectedFileType: null,
                selectedFile: null,
                fileName: null
            });
    };

    updateDocument = (action, file) => {
        switch (action) {
        case "APPROVE":
            this.props.validateDocument(
                this.props.companyId,
                file
            );
            break;
        case "REJECT":
            this.props.invalidateDocument(
                this.props.companyId,
                file
            );
            break;
        case "DELETE":
            this.props.invalidateDocument(
                this.props.companyId,
                file
            );
            this.setState({
                selectedFilePath: null,
                selectedFileType: null,
                selectedFile: null,
                fileName: null
            });
            break;
        default:
            break;
        }
        /*eslint-enable*/
    };

    updateData = (values) => {
        let companyData = this.props.profile.get("data");
        if (values) {
            companyData = companyData.updateBankAccounts(values);
        }
        this.props.updateCompanyLosProfile(this.props.companyId, companyData);
    }

    toggleRequestModal = () => {
        this.setState({
            requestModal: !this.state.requestModal
        });
    };

    requestDocumentsHandler = () => {
        this.toggleRequestModal();
    }

    sendRequestToDocument = () => {
        let selectedFileWithRemark = { ...this.state.selectedFile, ...{ request_remarks: this.state.requestedRemarks } };
        this.props.addRequestRemarks(
            this.props.companyId,
            this.state.selectedFile.id,
            selectedFileWithRemark,
            this.props.caseId
        );
        this.setState(
            {
                selectedFilePath: null,
                selectedFileType: null,
                selectedFile: null,
                fileName: null,
                requestedRemarks: null,
                showRequestedRemarks: false
            });
    }

    closeRequestRemarksModal = () => {
        this.setState({
            showRequestedRemarks: false,
            requestedRemarks: null
        });
    }

    render() {
        const isOnboardingCase = this.props.isDBOnBoarding || this.props.anchorOnboarding;
        return (
            <React.Fragment>
                <Modal
                    visible={this.state.showRequestedRemarks}
                    title={"Add Request Remarks"}
                    destroyOnClose
                    onOk={this.sendRequestToDocument}
                    onCancel={this.closeRequestRemarksModal}
                >
                    <Input.TextArea onChange={(e) => {
                        this.setState({
                            requestedRemarks: e.target.value
                        });
                    }} value={this.state.requestedRemarks} />
                </Modal>
                {isOnboardingCase && <DocumentRequestModal
                    isOnboardingCase = {isOnboardingCase}
                    associates ={this.props.profile.getIn(["data", "associates"])}
                    requestModal={this.state.requestModal}
                    requestDocumentsHandler={this.requestDocumentsHandler}
                    companyId={this.props.companyId}
                    closeRequestModal={this.toggleRequestModal}
                />}
                <CompanyAttachmentUploadModal
                    isVisible={this.state.isUploadModalVisible}
                    onClose={this.toggleUploadModal}
                    formSubmitting={this.isFormSubmitting()}
                    formSubmitFailed={this.isFormSubmitFailed()}
                    onSubmit={this.onSubmit}
                    values={this.getFormValues()}
                />
                <Row className={"p-5"}>
                    <Col span={7} className={"p-10"}>
                        {/* <CompanyAttachmentTable
                            attachments={this.getValues()}
                            loading={this.getLoading()}
                            companyId={this.props.companyId}
                        /> */}
                        <CompanyDocumentViewList
                            viewUploadButton={!this.props.isDBOnBoarding}
                            isOnboardingCase={isOnboardingCase}
                            openRequestModal={this.toggleRequestModal}
                            files={this.getValues()}
                            docFiles = {List(this.props.attachments.get("data", new List([])))}
                            viewDoc={this.viewDoc}
                            toggleUploadModal={this.toggleUploadModal}
                            selectedFileId={
                                this.state.selectedFile &&
                                this.state.selectedFile.id
                            }
                            changeName={this.changeName}
                            companyId={this.props.companyId}
                            loading={this.getLoading()}
                            deleteRequestedDocument={
                                this.deleteRequestedDocument
                            }
                            addRequestedRemark={this.addRequestedRemark}

                        />
                    </Col>
                    <Col span={17}>
                        <DocumentViewForm
                            isOnboardingCase={isOnboardingCase}
                            file={this.state.selectedFile}
                            selectedFilePath={this.state.selectedFilePath}
                            selectedFileType={this.state.selectedFileType}
                            docMasterList={this.docMasterList}
                            updateDocument={
                                this.updateDocument
                            }
                            updateBankAccounts={this.updateData}
                            bankAccounts={
                                this.props.profile &&
                                this.props.profile.getIn(["data", "bank_accounts"])
                            }
                        />
                    </Col>
                </Row>
            </React.Fragment>
        );
    }
}


CompanyAttachmentsDisplay.propTypes = {
    companyId: PropTypes.string,
    location: PropTypes.object,
    history: PropTypes.object,
    attachments: PropTypes.object,
    fetchCompanyLosAttachments: PropTypes.func,
    uploadCompanyLosAttachment: PropTypes.func,
    validateDocument: PropTypes.func,
    invalidateDocument: PropTypes.func,
    profile: PropTypes.object,
    updateCompanyLosProfile: PropTypes.func,
    docMasterListStatus: PropTypes.string,
    docMasterList: PropTypes.array,
    isDBOnBoarding: PropTypes.bool,
    fetchDocumentTypes: PropTypes.func,
    addRequestRemarks: PropTypes.func,
    anchorOnboarding: PropTypes.bool
};

export default CompanyAttachmentsDisplay;